import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const EQUIPMENT_DOWNTIME_REPORT_CONFIG: ReportConfig = {
  id: 'equipment-downtime',
  title: 'Equipment Downtime Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.EQUIPMENT_DOWNTIME.VIEW,
    export: PERMISSIONS.GSE.REPORTS.EQUIPMENT_DOWNTIME.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search',
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range',
    },
    {
      type: 'dropdown',
      field: 'equipment',
      label: 'Equipment',
      placeholder: 'Equipment',
      required: true,
      multiselect: false
    },
  ],

  columns: [
    {
      field: 'startDate',
      header: 'Start Date',
      type: 'text',
      pipes: ['date'],
      width: '15%',
    },
    {
      field: 'endDate',
      header: 'End Date',
      type: 'text',
      pipes: ['date'],
      width: '15%',
    },
    {
      field: 'totalHours',
      header: 'Total Hours',
      type: 'number',
      width: '12%',
    },
    {
      field: 'downTimeReason',
      header: 'Down Time Reason',
      type: 'text',
      pipes: ['replaceUnderscore', 'formatStatusDescriptive', 'titlecase'],
      width: '58%',
    },
  ],
};
